<script setup lang="ts">
  interface Props {
    isGooded: boolean;
    count: number;
    clickable: boolean;
    color?: string;
  }
  const props = defineProps<Props>();
  const textColor = computed<string>(() => {
    if (props.color) {
      return `text-${props.color}`;
    }
    return "";
  });
</script>

<template>
  <div
    class="good-button d-flex"
    :class="[isGooded ? `gooded` : `not-gooded ${textColor}`, clickable ? 'cursor-pointer' : '']"
  >
    <v-icon v-if="isGooded" icon="$mdiThumbUp" :size="18" />
    <v-icon v-else icon="$mdiThumbUpOutline" :size="18" />
    <div class="good-count">{{ count.toLocaleString() }}</div>
  </div>
</template>

<style lang="scss" scoped>
  .good-button {
    border-radius: 15px;
    height: 30px;
    padding: 6px 12px;
    font-size: 10px;
    font-weight: 700;
    line-height: 24px; // アイコンがズレるので個別に指定
  }
  .good-count {
    margin-top: -3px;
    margin-left: 8px;
  }
  .gooded {
    color: rgb(var(--v-theme-main-01));
    background-color: rgb(var(--v-theme-monochrome-01));
  }
  .not-gooded {
    background-color: rgb(var(--v-theme-monochrome-03));
  }
</style>
